import { Injectable } from '@angular/core';
import { MailboxData } from '../models/mailboxes.model';
import { CustomerAccount } from '@proximus/common-business-logic';
import { MailboxEntity } from '../config/mail-entity.config';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { CustomerService } from '@proximus/ng-common';
import { Observable } from 'rxjs';

@Injectable()
export class MailboxesService {
  constructor(private customerService: CustomerService) {}

  getMailboxes(
    customerAccount: CustomerAccount,
    appBrand?: string,
  ): Observable<IEntity<MailboxData>> {
    // this.mailboxData$ = this.customerService
    //   .getCustomerAccount()
    //   .switchMap((customerAccount: CustomerAccount) => {
    //     return EntityManager.getEntity(MailboxEntity,
    //       {cdbId: customerAccount.flsDefaultCustomer.customerId});
    //     });
    // return this.mailboxData$;
    return EntityManager.getEntity(MailboxEntity, {
      cdbId: customerAccount.flsDefaultCustomer.customerId,
      appBrand,
    });
  }

  createMailbox(cdbId: string, aliasId: string, password: string) {
    const createMailboxEntity = EntityManager.createEntity(MailboxEntity, {});
    createMailboxEntity.value = {
      cdbId,
      aliasId,
      password,
    };
    return EntityManager.saveEntity(createMailboxEntity);
  }
}
